import * as React from 'react';
import strings from 'owa-strings/owa-tasks-strings';
import { observer } from 'mobx-react';
import { StarCharm } from 'owa-star-charm';

const styles = require('./TodoStarCharm.scss');

export interface TodoStarCharmProps {
    onClick: () => void;
    isImportant: boolean;
    style: string;
}

@observer
export default class TodoStarCharm extends React.Component<TodoStarCharmProps, {}> {
    render() {
        const { isImportant, style } = this.props;
        return (
            <StarCharm
                isStarred={isImportant}
                onClick={this.onClick}
                iconStyles={styles.star}
                ariaLabelText={isImportant ? strings.taskImportantAriaText : 'Not Important'}
                tooltip={{
                    starred: strings.removeImportance,
                    unstarred: strings.markAsImportant,
                }}
                buttonStyles={{ root: style }}
            />
        );
    }

    private onClick = (evt: React.MouseEvent<EventTarget>) => {
        evt.stopPropagation();
        this.props.onClick();
    };
}
